import { Skeleton } from "@/components/shared/Skeleton";
import { THUMBNAIL } from "@/lib/constants/shared";
import type { ViewMode } from "@/types/viewMode";

interface LessonCardSkeletonProps {
  viewMode?: ViewMode;
}

export function LessonCardSkeleton({ viewMode = "grid" }: LessonCardSkeletonProps) {
  /* ---------------- LIST VIEW ---------------- */
  if (viewMode === "list") {
    return (
      <div className="relative panel p-4 flex gap-5 items-center">
        {/* Thumbnail */}
        <Skeleton
          className={`w-32 h-32 ${THUMBNAIL.lessonAspectRatioClass} rounded-lg flex-shrink-0 bg-gray-800`}
        />

        {/* Divider */}
        <div className="h-24 w-px bg-gradient-to-b from-transparent via-gray-800 to-transparent" />

        {/* Content */}
        <div className="flex-1 space-y-3">
          {/* Title */}
          <Skeleton className="h-5 w-2/3 bg-gray-700" />
          <div className="flex flex-col gap-3">
            {/* Grammar box */}
            <div className="p-4 rounded-lg border border-gray-800 bg-gray-900 space-y-2">
              <Skeleton className="h-3 w-24 bg-gray-700" />
              <Skeleton className="h-4 w-full bg-gray-700" />
            </div>

            {/* Linked Copies section */}
            <div className="py-5 px-3 space-y-1.5 border rounded-lg">
              <Skeleton className="h-4 w-3/4 bg-gray-700" />
              <Skeleton className="h-3 w-1/2 bg-gray-700" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  /* ---------------- GRID VIEW ---------------- */
  return (
    <div className="relative panel overflow-hidden">
      {/* Thumbnail */}
      <Skeleton
        className={`${THUMBNAIL.lessonAspectRatioClass} w-full rounded-t-xl bg-gray-800 border-b-2 border-gray-800`}
      />

      {/* Content */}
      <div className="px-4 py-4 space-y-3">
        {/* Title (2 lines) */}
        <div className="space-y-4 mb-6">
          <Skeleton className="h-4 w-3/4 bg-gray-700" />
          <Skeleton className="h-4 w-1/2 bg-gray-700" />
        </div>

        {/* Grammar box */}
        <div className="p-3 rounded-lg border border-gray-800 bg-gray-900 space-y-2">
          <Skeleton className="h-5 w-24 bg-gray-700" />
          <Skeleton className="h-4 w-full bg-gray-700" />
        </div>

        {/* Linked Copies section */}
        <div className="py-5 px-3 space-y-1.5 border rounded-lg">
          <Skeleton className="h-4 w-3/4 bg-gray-700" />
          <Skeleton className="h-3 w-1/2 bg-gray-700" />
        </div>
      </div>
    </div>
  );
}
